import React from 'react';

import FormItemEditor from './FormItemEditor';
import FormItemConst from './FormItemConst';
import {RecordFieldChangeStore,AutoSaveBeforeStore} from '../stores/RecordsStore';
import RecordsActions from '../actions/RecordsActions';
import FocusActions from '../actions/FocusActions';
import FormItemDateTimeDisplay from './display/FormItemDateTimeDisplay';
import FormItemDateTimeResolver from './resolver/FormItemDateTimeResolver';
import Warning from '../utils/Warn';
import CommonUtil from '../utils/CommonUtil';


export default class FormItemDateTimeEditor extends FormItemEditor
{
	lookupStates = 
	{
		isShowed:false
	}

	constructor(props) {
		super(props);
		this.initMembers();
		this.initStores();
	}

	initMembers()
	{

	}

	initStores()
	{
		if(!this.props.forLookup)
		{	
			this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
			this.unsubscribeAutoSaveBeforeStore = AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
		}
	}

	componentWillUnmount()
	{
		this.distroyCommonStores();
		if(!this.props.forLookup)
		{
			this.unsubscribeRecordFieldChangeStore();
			this.unsubscribeAutoSaveBeforeStore();
		}
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(observer != this && this.props.dataField == dataField && record == this.record)
		{
			this.setDisplay(newValue);
			this.updateModifiedTag();
		}
	}

	onCmdWriteControlStore(arg,moduleInstanceId,triggerModify)
	{
		if(arg && arg.hasOwnProperty(this.props.xml.name) && this.props.moduleInstanceId == moduleInstanceId)
		{
			var value = arg[this.props.xml.name];
			this.setDisplayFieldText(value,triggerModify)
			if(this.props.underQueryGroup)
			{
				this.setQueryGroupEnable(true);
			}
		}
	}

	dateSelectChange()
	{
		alert('select changeDate')
	}

	showDateDropDown()
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(!nowAllowEdit)
			return;
		let pickerObj = $(this.flatpickrDom)[0]._flatpickr;
		if(!pickerObj)return;

		if(pickerObj.isOpen)
		{
			this.lookupStates.isShowed = false;
			pickerObj.close();
		}
		else
		{
			this.lookupStates.isShowed = true;
			pickerObj.open();
		}
	}

	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{
		super.onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId);
		if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.currentDataFieldChanged = false;
			this.doSetModifiedTagNone();
			if(this.props.dataField)
			{
				var _value = this.record?this.record[this.props.dataField]:'';
			}
			else
			{
				_value = this.record;
			}
			//var _value = (this.record&&this.props.dataField)?this.record[this.props.dataField]:"";
			this.setDisplay(_value);

			if(this.props.control)
			{

				var _allowEdit = true;
				if(!this.record && groupAlias)
				{
					_allowEdit = false;
				}
				else
				{
					_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
				}
				this.doSetEnable(_allowEdit);	
			}
		}
	}

	onDatePanelClose()
	{
		this.lookupStates.isShowed = false;
		$(this.inputField).select().focus();
	}

	onDatePanelChange()
	{
		this.setFinalValue();
		this.setDisplay();
	}

	selectChangeDate()
	{
		this.setFinalValue();
		this.setDisplay();
	}

	componentDidMount()
	{
		super.componentDidMount();
        $(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
        

		//CommonUtil.dynamicLoadJs("")
		
		window.Flatpickr.l10n.weekdays = 
		{
			shorthand: ["三", "一", "二", "三", "四", "五", "六"],
			longhand: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期天"]
		};

		window.Flatpickr.l10n.months = {
			shorthand: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
			longhand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
		},
		
		$(this.flatpickrDom).flatpickr(
			{enableTime:true,allowInput:true,onChange:this.onDatePanelChange.bind(this),
				onClose:this.onDatePanelClose.bind(this),time_24hr:true,
				minuteIncrement:1,clickOpens:false,wrap:true,enableSeconds:true}
		);


		if(this.props.underQueryGroup)
		{
			this.doSetEnable(true);
		}
		else
		{
			let _initRecord;
			if(this.props.dataField)
			{
				_initRecord = this.props.initRecord;
			}
			else
			{
				if(this.props.control.hasInitEditorValue)
				{
					_initRecord = this.props.initEditorValue;	
				}
				else
				{
					_initRecord = this.props.initRecord;
				}
				//_initRecord = this.props.initEditorValue;
			}
			this.onCurrentRecordChanged(null,_initRecord,this.props.groupAlias,this.props.moduleInstanceId);	
		}

		if(this.props.initEditorValue && !this.props.dataField)
		{
			this.setFinalValue(this.props.initEditorValue,false);
			this.setDisplay();
		}
	}

	doSetEnable(enable)
	{
		var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			this.setState({allowEdit:false});
		}
		else if(nowAllowEdit == false && enable == true)
		{
			this.setState({allowEdit:true});
		}
	}

	onBeforeAutoSave(groupAlias)
	{
		if(this.props.groupAlias == groupAlias)
		{
			if($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length)
			{
				let text = $(this.inputField).val();
				let _val;
				_val = FormItemDateTimeResolver.getResult(text,false);
				if(_val.indexOf("false:") == 0)
				{
					//alert(_val.substr(6));
					return false;
				}
				if(this.props.groupAlias == "")
				{
					this.record = _val;
				}
				else
				{
					let changed = false;
					let oldValue = this.record[this.props.dataField];
					let newValue = _val;
					if(oldValue != newValue)
						changed = true;
					this.record[this.props.dataField] = newValue;
					//alert("派发");	
					if(changed)	
					{
						RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
						if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"");
					}
					this.updateModifiedTag();
				}
			}
		}
		return true;
		
	}

	setFinalValue(value,triggerModified = true)
	{
		if(value == undefined || value == null)
			value = $(this.inputField).val();
		if(value == "t" || value == "T")
		{
			var today = new Date();
			var fullYear = today.getFullYear();
			var fullMonth = today.getMonth()+1;
			var fullDate = today.getDate();
			if(fullMonth < 10)
				fullMonth = "0"+fullMonth;
			if(fullDate < 10)
				fullDate = "0"+fullDate;

			value = fullYear+""+fullMonth+""+fullDate+"120000"
		}
		if(value)
		{
			value = FormItemDateTimeResolver.getResult(value,false);
			if(value.indexOf("false:") == 0)
			{
				Warning.show({text:value.substr(6)});
				return false;
			}
		}
		
		if(!this.props.dataField)
		{
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				var oldValue = this.record;var newValue = value;this.record = value;
			
				if(this.props.control && oldValue != newValue && triggerModified)
				{
					this.props.control.doModifiedEditor(oldValue, newValue,this);
				}
			}
			this.record = value;
		}
		else
		{
			let changed = false;
			let oldValue = (this.record&&this.props.dataField)?this.record[this.props.dataField]:(this.record?this.record:"");
			let newValue = value;
			if(oldValue != newValue)
				changed = true;
			this.record[this.props.dataField] = newValue;
			//alert("派发");	
			if(changed)	
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"",null,this);
			}
			this.updateModifiedTag();
		}
		var pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
		var formatedDate = value.replace(pattern, '$1/$2/$3 $4:$5:$6');
		var ddate = new Date(formatedDate);
		$(this.flatpickrDom)[0]._flatpickr.setDate(ddate);
	
		return true;
	}

	//新框架避免增加复杂条件判断 所以该类只表示Form上FormItem
	inputFieldBlur()
	{
		if(this.lookupStates.isShowed)
			return;
		if(this.props.control && this.props.control.getProperty_AllowEdit_Final() == true)
		{
			//todo 值回送数据完成以后 严格按照显示要求再进行显示
			this.setFinalValue();
			this.setDisplay();
		}

		if(this.holdFocus)
		{
			$(this.inputField).focus();
			$(this.inputField).select();
		}
	}

	setDisplay(value)
	{
		if(value == null || value == undefined)
		{
			if(this.props.dataField && this.record)
				value = this.record[this.props.dataField];
			else
				value = this.record;
		}
		if(document.activeElement && document.activeElement == this.inputField)
		{

		}
		else
		{
			//let _displayStyle = this.props.control.getProperty_DisplayStyle();
			let _dislayFormat = this.props.displayFormat;
			if(_dislayFormat)
			{
				value = FormItemDateTimeDisplay.getDisplayText2(value,_dislayFormat);
			}
			else
			{
				value = FormItemDateTimeDisplay.getDisplayText(value);
			}
			
		}
			

		$(this.inputField).val(value);
	}

	inputFieldFocus()
	{
		//return;
		window.lastFocusUI = this.inputField;
		if(this.props.groupAlias)
			window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
		if(this.lookupStates.isShowed)
			return;
		if(!this.props.dataField)
		{
			$(this.inputField).val(this.record);
		}
		else
		{
			let _recordValue = this.record==null?"":this.record[this.props.dataField];
			$(this.inputField).val(_recordValue);	
		}
		var _parentWindow =window;	
		if(_parentWindow.notClickFocusEditor){
			_parentWindow =window;
		}else if(window.parent.window.notClickFocusEditor){
			_parentWindow =window.parent.window;
		}
		if(_parentWindow.notClickFocusEditor == undefined || (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '')
			|| (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1 )){
			$(this.inputField).select();
		}
	}

	onKeyDownHandler(e)
	{
		if(super.onKeyDownHandler(e))
			return;
		if(e.keyCode>64&&e.keyCode<91&&e.keyCode!=84)
		{
			e.preventDefault();
		}
		if(e.ctrlKey && e.keyCode == 40)
		{
			let pickerObj = $(this.flatpickrDom)[0]._flatpickr;
			if(!pickerObj)return;
			pickerObj.open();this.lookupStates.isShowed = true;
		}
		else if(e.ctrlKey && e.keyCode == 38)
		{
			let pickerObj = $(this.flatpickrDom)[0]._flatpickr;
			if(!pickerObj)return;
			pickerObj.close();this.lookupStates.isShowed = false;
		}
	}

	inputFieldDbClick()
	{
		var _parentWindow =window;	
		if(_parentWindow.notClickFocusEditor){
			_parentWindow =window;
		}else if(window.parent.window.notClickFocusEditor){
			_parentWindow =window.parent.window;
		}
		if(_parentWindow.notClickFocusEditor == undefined || (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '')
			|| (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1 )){
			$(this.inputField).select();
		}
	}

	getInputDom(_width)
	{
		if(this.state.allowEdit)
		{
			let height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT;
			if(this.props.displayHeight){
				height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT*(Number(this.props.displayHeight));
			}
			let _style = {padding:'2px',paddingRight:'13px',height:(height)+'px',width:_width,fontSize:"12px"};
			_style.textAlign = this.props.textAlign.toLowerCase();
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
			if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			if(this.state.backgroundColor && this.state.backgroundColor != -1)_style.backgroundColor = this.state.backgroundColor;
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);
			return 	 <input data-input spellCheck="false" autoComplete="off" ref={ node => this.inputField = node } id={"input"+this.props.xml.id} 
                        type="text" className="form-control pull-right" style={_style}
                        onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>;
        }   
		else
		{
			let height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT;
			if(this.props.displayHeight){
				height = this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT*(Number(this.props.displayHeight));
			}
			let _style = {padding:'2px',paddingRight:'13px',height:(height)+'px',width:_width,backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px",cursor:'text'};
			_style.textAlign = this.props.textAlign.toLowerCase();
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
			if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);
			return	 <input data-input spellCheck="false" autoComplete="off" ref={ node => this.inputField = node } id={"input"+this.props.xml.id} readOnly="readonly" 
		        	   type="text" className="form-control pull-right" style={_style}
		        	   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} onKeyDown={this.onKeyDownHandler.bind(this)}/>;
		}
	}

	getDownArrowButtonDom()
	{
		if(this.state.allowEdit)
		{
			return <i ref={node => this.downArrowButton = node} onClick={this.showDateDropDown.bind(this)} className="fa fa-calendar" style={{position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
			//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'18px',paddingLeft:'0px',paddingRight:'0px',height:'22px',paddingBottom:'2px'}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
		}
		else
		{
			return <i ref={node => this.downArrowButton = node} className="fa fa-calendar" style={{position:'absolute',top:'calc(100% / 2 - 5.5px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>
			//return <div ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',paddingTop:'2px',width:'18px',paddingLeft:'0px',paddingRight:'0px',height:'22px',paddingBottom:'2px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR}} onMouseDown={this.showDateDropDown.bind(this)}><i className="fa fa-calendar"></i></div>;
		}
	}

	render()
	{
		let _display = this.currentDataFieldChanged?"block":"none";
		let displayLength=this.state.displayLength;
		let paddingRightValue = 0;
		if(displayLength == FormItemConst.DATEEDITOR_DEFAULT_DISPLAYLENGTH)displayLength=FormItemConst.DATEEDITOR_DEFAULT_DISPLAYLENGTH+1;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+paddingRightValue+'px';
		let notNull=this.state.notNull;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';

		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		if(_display == "block")editorStyle.backgroundColor = "#f8e8b7";
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) editorStyle.display="none"; else editorStyle.visibility="hidden";

			// _notNullStyle['display']='none';
		let widthProValue = this.props.control.getProperty_Width();
		let middleStyle = {};
		if(widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1)
		{
			_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
		}

		let inputdom = this.getInputDom(_width);
		let downArrowButtonDom = this.getDownArrowButtonDom();
		let labelStyle = {paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		if(this.state.underQueryGroup && !this.inQueryGroup)
		{
			labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
		}
		if(!this.props.label){labelStyle.display = "none";_notNullStyle.display = "none"}
		return (
			<div id={this.props.xml.name} className='editorGroup' ref={node=>this.contextMenuHandler=node} style={editorStyle}>
			  <label htmlFor={"input"+this.props.xml.id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
			  		 {this.state.label}
			  </label>
			  <i className='fa fa-snowflake-o' style={_notNullStyle}></i>
			  <div className="input-group date" style={middleStyle} ref={node=>this.flatpickrDom=node}>
			  	{inputdom}{downArrowButtonDom}
		        <i ref={node => this.modifiedTag = node} className="fa fa-sort-asc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-5px",right:"-3px",fontSize:"11px",transform:'rotate(45deg)',zIndex:"100",marginRight:'4.5px',marginTop:'4px',display:_display}}></i>
		      </div>
		       
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/formItem/FormItemDateTimeEditor.js